import { render, staticRenderFns } from "./attr-custom.vue?vue&type=template&id=7728c12c&scoped=true"
import script from "./attr-custom.vue?vue&type=script&lang=js"
export * from "./attr-custom.vue?vue&type=script&lang=js"
import style0 from "./attr-custom.vue?vue&type=style&index=0&id=7728c12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7728c12c",
  null
  
)

export default component.exports